import { Injectable } from '@angular/core';
import { ConfigDB } from '../data/config';

@Injectable({
  providedIn: 'root'
})
export class CustomizeService {

  constructor() {
    var layoutVersion = this.data.settings.layout_version
    if (layoutVersion) {
      document.body.classList.add(layoutVersion);
      this.data.settings.layout_version = layoutVersion
    }
  }

  // Configuration Layout
  public data = ConfigDB.data

  // Set Customize layout Version
  setLayoutVersion(layout) {
    document.body.classList.remove(this.data.settings.layout_version);
    this.data.settings.layout_version = layout
    document.body.classList.add(layout);
  }

}
